<template>
<section class="app-content" :class="collapsed ? 'longer' : ''">
    <div class="app-breadcrumb-nav">
        <span class="title" v-if="$route.path === '/home'">{{$t(/*你好！欢迎使用HORWIN IOT平台*/'tip.welcome')}}</span>
        <el-breadcrumb separator="/" v-else>
            <el-breadcrumb-item v-for="(item, index) of navList" :key="index" :to="{ path: item.path }">{{$t('title.' + item.key)}}</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <div class="main-container">
        <transition name="fade" mode="out-in">
            <router-view></router-view>
        </transition>
    </div>
</section>
</template>

<script>
export default {
    name: 'AppContent',
    props: {
        collapsed: { type: Boolean, default: false }
    },
    data() {
        return {
            navList: [],
        }
    },
    watch: {
        $route: {
            deep: true,
            immediate: true,
            handler(n) {
                console.log('watch $route:', n)
                let navList = n.matched.map(item => {
                    return {
                        path: item.path,
                        ...item.meta,
                    }
                })
                let currIndex = navList.findIndex(item => item.path === n.path)
                navList[currIndex].path = n.fullPath
                this.navList = navList
            }
        }
    },
    mounted() {
    }
}
</script>

<style scoped lang="scss">
.app-content {
    width: calc(100% - 200px);
    display: flex;
    flex-direction: column;
    height: 100%;
    &.longer {
        width: calc(100% - 78px);
    }
    .app-breadcrumb-nav {
        height: 40px;
        width: 100%;
        background: white;
        border-bottom: 1px solid #dce2e8;
        padding-left: 20px;
        box-sizing: border-box;
        @include fac();
        .title {
            color: #34383e;
            font-size: 12px;
            cursor: default;
        }
    }
    .main-container {
        flex: 1;
        height: calc(100% - 40px);
        overflow: auto;
        padding: 20px;
        box-sizing: border-box;
    }
}
</style>
